import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HomePage } from './homePage';
import DiagnosticResult from './diagnosticResult/index';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/diagnostic" element={<DiagnosticResult />} />
      </Routes>
    </Router>
  );
}

export default App;